import Controller from '@ember/controller';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import type { LinkManagerService } from 'ember-link';
import type { Tab } from 'walden-fast/components/tabs';

export default class AppManageSubscriptionsController extends Controller {
  @service('intl') declare intlService: IntlService;
  @service('link-manager') declare linkManager: LinkManagerService;

  get tabs(): Tab[] {
    return [
      {
        internalLink: this.linkManager.createLink({
          route: 'app.manage.subscriptions.services',
        }),
        label: this.intlService.t('pages.manage.subscriptions.tabs.services'),
        type: 'internal',
      },
      {
        internalLink: this.linkManager.createLink({
          route: 'app.manage.subscriptions.invoices',
        }),
        label: this.intlService.t('pages.manage.subscriptions.tabs.invoices'),
        type: 'internal',
      },
    ];
  }
}
